import { render, staticRenderFns } from "./techhome.vue?vue&type=template&id=39df4773&scoped=true&"
import script from "./techhome.vue?vue&type=script&lang=js&"
export * from "./techhome.vue?vue&type=script&lang=js&"
import style0 from "./techhome.vue?vue&type=style&index=0&id=39df4773&lang=scss&scoped=true&"
import style1 from "./techhome.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "39df4773",
  null
  
)

export default component.exports